module.exports = __webpack_public_path__ + "img/content_copy.5b7b53ce.svg";